import {Alert, AlertDescription} from "@/components/ui/alert";
import {cn} from "@/lib/utils";

type ResidentAmenityRestrictionNoticeProps = {
  message: string;
  className?: string;
};

export function ResidentAmenityRestrictionNotice({
  message,
  className,
}: ResidentAmenityRestrictionNoticeProps) {
  return (
    <Alert variant="destructive" className={cn("py-2", className)}>
      <AlertDescription className="text-sm leading-snug">{message}</AlertDescription>
    </Alert>
  );
}
